type URLString = string;
type ImageUrl = string;
type TimeString = string; // "2020-06-24T02:42:37.356Z"

export interface ProductListItem {
    productId: number; // todo: 改成id，和Brand保持一致
    thumbnail: string;
    name: string;
    categoryTxt: string;
    fileExtName: string;
    brand: string; // 品牌名字
    updatedAt?: string; // "2020-06-22T05:31:52.512Z"
    downloadedAt?: string; // "2020-06-22T05:41:57.432Z"
}

export interface ProductCard {
    id: string;
    name: string;
    modelNumber: string;
    imageUrl: ImageUrl;
    brandName: string;
    brandLogo: string;
    browsedCount: number;
    collectedCount: number;
    certLogos: ImageUrl[]; // 认证、区块链
    isNew: boolean; // 7天内更新
    isCollected: boolean;
    pvId: string;
}

// todo: 也给一个ID上来吧
export interface ProductDetail {
    pvId: number;
    series: string;
    group: string;
    releasedTime: TimeString;
    version: string;
    type: string;
    description: string;
    drawings: URLString; // 图纸
    images: string[];
    certifications: {
        logo: ImageUrl;
    }[];
    brand: {
        name: string;
        logo: ImageUrl;
        productCount: number;
        fansCount: number;
    };
}

export interface ProductProperty {
    name: string;
    value: string;
}

export interface ProductStandardCode {
    name: string;
    value: string;
}

export interface ProductQuality {
    ce: boolean;
    fireRating: string;
    certifications: {
        logo: ImageUrl;
    }[];
    traceSourceCode: string;
    standards: string[];
}

export interface ProductTechDoc {
    name: string;
    cover: ImageUrl;
    url: URLString;
}

// todo: 不符合设计
export interface ProductCorrelation {
    id: number;
    thumbnail: ImageUrl;
}

export interface Properties {
    productId: number;
    pvId: number;
    name: string;
    modelCode: string;
    thumbnail: string;
    brand: string;
    properties: ComparisonProperties[];
    modelGroupId: string;
    threeDModel: string;
    drawings: string;
}
export interface ComparisonProperties {
    name: string;
    unit: string;
    value: string;
}
export interface Models {
    productId: 0;
    pvId: 0;
    name: string;
    modelCode: string;
    thumbnail: string;
    brand: string;
    properties: [
      {
        name: string;
        unit: string;
        value: string;
      }
    ];
    modelGroupId: string;
    threeDModel: string;
    drawings: string;
}
export interface UserSummary {
    collectedCount: number; // 收藏数量
    toBeUpdatedCount: number; // 待更新数量
    downloadedCount: number; // 已下载数量
    brandCount: number; // 产品数量
}

export interface UserBrand {
    brandId: number;
    logo: string;
    name: string;
    productCount: number;
    fansCount: number;
}

export interface User {
    userName: string; // 用户名，不可修改的
    nickName: string; // 昵称，可以修改的
    avatar: string;
    phoneNumber: string;
    company: string;
    profession: '建筑师';
    organization: string; // 公司
    country: string;
    province: string;
    city: string;
}

export interface BrandCard {
    brandId: number;
    name: string;
    productCount: number;
    logo: ImageUrl;
    fansCount: number;
    isConcerned: boolean;
}

export interface Brand {
    id: number;
    phone: string;
    email: string;
    webSite: string;
    address: string;
    summary: string;
    isFollower: string;
    certificationImages: string[];
    logo: URLString;
    name: string;
    productCount: number;
}

export interface Filter {
    id: number;
    name: string;
}

export interface FilterBrand extends Filter {
    logo: string;
    productCount: number;
}

export interface FilterCategory extends Filter {
    level: number;
    productCount: number;
    children: FilterCategory[];
}

export interface FilterFileType {
    name: string;
    productCount: number;
}

export interface FilterAdvanced {
    name: string;
    keyword: string;
    rangeInput?: {
        minValue: number;
        maxValue: number;
    };
    listSelect?: string[];
}

export interface FileTyps {
    extensionName: string;
    icon: string;
    url: string;
}

/**
 * 消息
 */
export interface NewsItem {
    id: string;
    category: string;
    icon: string;
    title: string;
    content: string;
    isReaded: boolean;
    breviary: string;
    change: boolean;
    extData: {
        additionalProp1: any;
        additionalProp2: any;
        additionalProp3: any;
    };
}

export interface CompareList {
    'productId': string;
    'pvId': string;
    'name': string;
    'thumbnail': string;
    'brand': string;
}

/**
 * 作业-分页
 */
export interface TasksItem{
    createUserBane: string;
    createNickName: string;
    name: string;
    typeId: number;
    beginTime: string|Date;
    endTime: string|Date;
    logo: string;
    remark: string;
    targetType: number;
    creationTime: string|Date;
    createUserId: number|string;
    id: string|number;
    status?: number;
}

/**
 * 作业资料-分页
 */
// eslint-disable-next-line @typescript-eslint/class-name-casing
export interface taskFile{
    uploadFileId: number|string;
    taskId: number|string;
    isTaskRule: boolean;
    taskRuleId: number|string;
    creationTime: string;
    createUserId: number|string;
    id: number|string;
}
// eslint-disable-next-line @typescript-eslint/class-name-casing
export interface upLoadFile{
    fileId: string;
    fileName: string;
    fileExtention: string;
    fileTaskId: string;
    fileConvertState: number;
    fileHash: string;
    fileSize: string| number;
    fileUrl: string;
    modelGroupId: string;
    type: number[];
    isLocked: boolean;
    creationTime: string | Date;
    createUserId: number|string;
    id: number|string;

}
// eslint-disable-next-line @typescript-eslint/class-name-casing
export interface taskFilesItem{
    taskFile: taskFile;
    uploadFile: upLoadFile;
}

export interface TaskNoticesItem{
    taskId: number|string;
    content: string;
    creationTime: string;
    createUserId: number|string;
    id: number|string;
}

// 文件文件列表
export interface FileData {
    name: string;
    percentage: number;
    raw: File;
    size: number;
    status: string;
    uid: number;
    fileId?: string;
    filePath?: string;
    error?: boolean;
  }
export interface TaskUserCommitsItem{
    checkReportInfo: any;
    commitFile: CommintFile;
    commitInfo: CommitInfo;
    nickName: string;
    phoneNumber: string;
    uploadFile: upLoadFile;
    userId: string;
    userName: string;
}

export interface CommintFile {
    createUserId: string;
    creationTime: string;
    id: string;
    isTaskRule: boolean;
    taskCommitId: string;
    taskId: string;
    taskRuleId: number;
    uploadFileId: string;
}
export interface CommitInfo{
    checkerId: number;
    checkerName: string;
    classId: number;
    createUserId: string;
    creationTime: any ;
    id: string;
    lastCheckTime: any;
    mark: number;
    nickName: string;
    remark: string;
    status: number;
    taskId: string;
    taskName: string;
    userId: string;
    userName: string;
}
export enum MEASURESTATE {
     /**
         * 距离测量
         */
      DIS = 0,
      /**
       * 角度测量
       */
      ANH = 1,
      /**
       * 面积测量
       */
      AREA = 2,
      /**
       * 体积测量
       */
      VOL = 3,
      /**
       * 坐标位置测量
       */
      POINT = 4,
      /**
       * 多点围合面积
       */
      PSENCLOSEAREA = 5
}
